module.exports = __webpack_public_path__ + "img/Beifahrerseite_1T_Frontmotor.14fc3c44.jpg";